import { render, staticRenderFns } from "./AdminAddNewOffice.vue?vue&type=template&id=fa9f4d50&scoped=true&"
import script from "./AdminAddNewOffice.vue?vue&type=script&lang=js&"
export * from "./AdminAddNewOffice.vue?vue&type=script&lang=js&"
import style0 from "./AdminAddNewOffice.vue?vue&type=style&index=0&id=fa9f4d50&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa9f4d50",
  null
  
)

export default component.exports